import * as React from "react";
import { Container, Box, Typography } from "@mui/material";

export default function AboutDopatize() {
  return (
    <Container id="about-page" maxWidth="md" sx={{ py: { xs: 4, md: 8 } }}>
      <Box id="about-story" component="article" sx={{ display: "grid", gap: 3 }}>
        <Typography variant="h3" component="h1" gutterBottom>
          About Dopatize
        </Typography>

        <Typography variant="body1" paragraph>
          Growing up, my mom used to say, <em>“You were born without an initiative muscle.”</em> She
          wasn’t wrong. Starting things felt impossible—especially stuff I didn’t want to do. She’d
          ask, <em>“Doesn’t it feel good when you finish something?”</em> and I’d just shrug. For me,
          finishing something was just relief that it was finally over, not a burst of pride.
        </Typography>

        <Typography variant="body1" paragraph>
          For years, I’d sit on my bed, overwhelmed by everything I had to do, mentally paralyzed.
          That constant dread turned into anxiety.
        </Typography>

        <Typography variant="body1" paragraph>
          A few years ago, someone suggested I might have ADHD. At first, I brushed it off—doesn’t
          everyone lose focus or get overwhelmed sometimes? But once I started digging deeper, I
          realized ADHD described my entire life. I wasn’t lazy. I wasn’t broken. My brain was wired
          differently. It wasn’t giving me enough dopamine—the motivation fuel that makes tasks feel
          rewarding in the first place.
        </Typography>

        <Typography variant="body1" paragraph>
          That’s when I learned about <strong>INCUP</strong>: Interest, Novelty, Challenge, Urgency,
          Passion. It’s the combo that really moves ADHD brains. I also noticed something important:
          <strong> computers are amazing at executive functioning</strong>—they organize, remember,
          and prioritize without getting overwhelmed. And <strong>video games are amazing at
          motivation</strong>—with rewards, feedback loops, and micro-goals that keep you engaged
          for hours. So why couldn’t real life work the same way?
        </Typography>

        <Typography variant="body1" paragraph>
          I went looking for an app that made life feel like a game instead of a boring checklist.
          What I found were tools that were too complicated, too “methodology-heavy,” or so flashy
          they just made me feel more stuck.
        </Typography>

        <Typography variant="body1" paragraph>
          So I built <strong>Dopatize</strong>.
        </Typography>

        <Typography variant="body1" paragraph>
          Dopatize isn’t just another productivity app. Productivity is about squeezing out the most
          tasks in the shortest time. Dopatize is about <strong>collecting dopamine, not guilt</strong>.
        </Typography>

        <Typography variant="body1" paragraph>
          Think of it like handing your to-do list over to a trusted friend. It breaks big tasks down
          into tiny, doable steps, takes care of the prioritizing, and gives you little bursts of
          reward every time you move forward. Instead of an endless mountain of tasks, you get one
          clear step at a time—plus a reason to actually feel good about finishing it.
        </Typography>

        <Typography variant="body1" paragraph>
          The magic isn’t just in getting things done—it’s in <strong>changing how you feel about
          doing them</strong>. Instead of ending your day thinking, “I didn’t do enough,” you end it
          thinking, “Look how much I actually accomplished.”
        </Typography>

        <Typography variant="body1" paragraph>
          At its core, Dopatize is built to spark motivation by being <em>interesting, novel,
          challenging, urgent,</em> and <em>passionate</em>—the very things that fuel the ADHD brain.
          The goal isn’t to chain you to another app, but to help you feel fulfilled, build habits
          that stick, and remind you that life itself is the game.
        </Typography>

        <Typography variant="body1" paragraph>
          <strong>Dopatize just makes sure you actually get the rewards.</strong>
        </Typography>
      </Box>
    </Container>
  );
}
